import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDataset from './dataset.reducer';
import { ProducerTypes } from '@mode/shared/contract-common';

export const selectDatasetState = createFeatureSelector<fromDataset.DatasetState>(fromDataset.datasetFeatureKey);
export const selectDataset = createSelector(selectDatasetState, (state) => state.dataset);
export const selectDatasetType = createSelector(selectDatasetState, (state) => {
  return state?.dataset?.result?.producerType ?? ProducerTypes.SqlQuery;
});
export const selectIsSheetDataset = createSelector(
  selectDatasetType,
  (datasetProducerType) => datasetProducerType === ProducerTypes.GoogleSheet
);
export const selectIsDatasetPublished = createSelector(
  selectDataset,
  (dataset) => !!dataset?.details?.thoughtspot?.publishedAt
);
export const selectDeleted = createSelector(selectDatasetState, (state) => state.deleted);
export const selectDeleteFromCollectionToken = createSelector(
  selectDatasetState,
  (state) => state.deleteFromCollectionToken
);
export const datasetName = createSelector(selectDataset, (dataset) => dataset?.details?.name || 'Untitled Dataset');
export const loadDatasetError = createSelector(selectDatasetState, (state) => state.loadDatasetError);

export const exportedDatasetSource = createSelector(selectDatasetState, (state) => state.exportedDatasetSource);

export const selectDatasetPublicationDetails = createSelector(
  selectDataset,
  (dataset) => dataset?.details?.thoughtspot
);
